import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { FormBuilder, FormGroup } from '@angular/forms';
import { loadingFade } from '../../animacoes';
import * as moment from 'moment';

import { AuthService } from '../services/auth.service';
import { ClienteService } from '../services/cliente.service';
import { UnidadeService } from '../services/unidade.service';
import { ProfissionalService } from '../services/profissional.service';
import { VeiculoService } from '../services/veiculo.service';
import { CheckMilimetragemService } from '../services/check-milimetragem.service';

@Component({
  selector: 'app-milimetragem-pneus-ver',
  templateUrl: './milimetragem-pneus-ver.component.html',
  styleUrls: ['./milimetragem-pneus-ver.component.css'],
	animations: [loadingFade]
})
export class MilimetragemPneusVerComponent implements OnInit {
  public loading;
  public submitting = false;
  public inicioPeriodo;

	public formChecklist: FormGroup;

  public agencias = [];
  public unidades = [];
  public profissionais = [];
  public veiculos = [];

  public check_milimetragem_id = null;
  public profissional = null;

    //filtro
    public cliente_id___cliente = null;
    public unidade_id___unidade = null;
    public veiculo_id___veiculo = null;
    public check_milimetragem_turno___periodo = null;
    public check_milimetragem_status___status = null;
    public check_milimetragem_data___data_i = null;
    public check_milimetragem_data___data_f = null;
    public profissional_id___profissional = null;

  // datepickers


  constructor(private authSvc: AuthService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private clienteSvc: ClienteService,
    private unidadeSvc: UnidadeService,
    private router: Router,
    private profissionalSvc: ProfissionalService ,
    private veiculoSvc: VeiculoService,
    private checkMilimetragemSvc: CheckMilimetragemService) { }

  ngOnInit() {
    this.pegaAgencias();
    this.pegaProfissionais();
    this.criaForm();
    this.loading = true;

		this.route.params.subscribe( params => {
			if (params.id) {
        

        var splitFiltro = params.id.split("?");

        if(splitFiltro[1] !== undefined){
          
          var splitfiltro = splitFiltro[1].split("&");
          for (let f in splitfiltro) {

            var loSplitValor = splitfiltro[f].split("=");

            switch(loSplitValor[0]) { 
              case "cliente_id___cliente": { 
                 this.cliente_id___cliente = loSplitValor[1];
                 break; 
              } 
              case "unidade_id___unidade": { 
                this.unidade_id___unidade = loSplitValor[1];
                 break; 
              } 
              case "veiculo_id___veiculo": { 
                this.veiculo_id___veiculo = loSplitValor[1];
                 break; 
              } 
              case "check_milimetragem_turno___periodo": { 
                this.check_milimetragem_turno___periodo = loSplitValor[1];
                 break; 
              }     
              case "check_milimetragem_data___data_i": { 
                this.check_milimetragem_data___data_i = loSplitValor[1];
                 break; 
              }      
              case "check_milimetragem_data___data_f": { 
                this.check_milimetragem_data___data_f = loSplitValor[1];
                 break; 
              }      
              case "profissional_id___profissional": { 
                this.profissional_id___profissional = loSplitValor[1];
                 break; 
              }                                                            
           }

          }


        }  

				this.check_milimetragem_id = params.id;
				this.checkMilimetragemSvc.getCheckMilimetragem(params.id).then((data: any) => {
          this.pegaUnidadesByAgencia(data.cliente_id);
          this.pegaVeiculosByUnidade(data.unidade_id);
					this.preencheForm({
            check_milimetragem_id:  data.check_milimetragem_id,
            usuario_id:  data.usuario_id,
            check_milimetragem_data:  moment(data.check_milimetragem_data, 'YYYY-MM-DD').format('DD/MM/YYYY'),
            check_milimetragem_turno:  data.check_milimetragem_turno,
            cliente_id:  data.cliente_id,
            unidade_id:  data.unidade_id,
            profissional_id:  data.profissional_id,
            veiculo_id:  data.veiculo_id,
            check_milimetragem_ed_s1: this.formatMilimetragem(data.check_milimetragem_ed_s1),
            check_milimetragem_ed_s2: this.formatMilimetragem(data.check_milimetragem_ed_s2),
            check_milimetragem_ed_s3: this.formatMilimetragem(data.check_milimetragem_ed_s3),
            check_milimetragem_ed_s4: this.formatMilimetragem(data.check_milimetragem_ed_s4),
            check_milimetragem_et_s1: this.formatMilimetragem(data.check_milimetragem_et_s1),
            check_milimetragem_et_s2: this.formatMilimetragem(data.check_milimetragem_et_s2),
            check_milimetragem_et_s3: this.formatMilimetragem(data.check_milimetragem_et_s3),
            check_milimetragem_et_s4: this.formatMilimetragem(data.check_milimetragem_et_s4),
            check_milimetragem_dd_s1: this.formatMilimetragem(data.check_milimetragem_dd_s1),
            check_milimetragem_dd_s2: this.formatMilimetragem(data.check_milimetragem_dd_s2),
            check_milimetragem_dd_s3: this.formatMilimetragem(data.check_milimetragem_dd_s3),
            check_milimetragem_dd_s4: this.formatMilimetragem(data.check_milimetragem_dd_s4),
            check_milimetragem_dt_s1: this.formatMilimetragem(data.check_milimetragem_dt_s1),
            check_milimetragem_dt_s2: this.formatMilimetragem(data.check_milimetragem_dt_s2),
            check_milimetragem_dt_s3: this.formatMilimetragem(data.check_milimetragem_dt_s3),
            check_milimetragem_dt_s4: this.formatMilimetragem(data.check_milimetragem_dt_s4),
					});
					this.loading = false;
				});
			}
			else {
				this.loading = false;
			}
    });
  }

  criaForm(){
    
    this.formChecklist = this.fb.group({
      check_milimetragem_id: null,
			usuario_id: null,
      check_milimetragem_data: {value: null, disabled: true},
      check_milimetragem_turno: {value: null, disabled: true},
      cliente_id: {value: null, disabled: true},
      unidade_id: {value: null, disabled: true},
      profissional_id: {value: null, disabled: true},
      veiculo_id: {value: null, disabled: true},
      check_milimetragem_ed_s1: {value: null, disabled: true},
      check_milimetragem_ed_s2: {value: null, disabled: true},
      check_milimetragem_ed_s3: {value: null, disabled: true},
      check_milimetragem_ed_s4: {value: null, disabled: true},
      check_milimetragem_et_s1: {value: null, disabled: true},
      check_milimetragem_et_s2: {value: null, disabled: true},
      check_milimetragem_et_s3: {value: null, disabled: true},
      check_milimetragem_et_s4: {value: null, disabled: true},
      check_milimetragem_dd_s1: {value: null, disabled: true},
      check_milimetragem_dd_s2: {value: null, disabled: true},
      check_milimetragem_dd_s3: {value: null, disabled: true},
      check_milimetragem_dd_s4: {value: null, disabled: true},
      check_milimetragem_dt_s1: {value: null, disabled: true},
      check_milimetragem_dt_s2: {value: null, disabled: true},
      check_milimetragem_dt_s3: {value: null, disabled: true},
      check_milimetragem_dt_s4: {value: null, disabled: true}
    });
  }

  preencheForm(dados) {
		this.formChecklist.setValue(dados);
  }

  pegaAgencias(){
    this.clienteSvc.getClientesByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
      this.agencias = data;
    }).catch((err) => {
      console.log(err);
    });
  }

  pegaUnidadesByAgencia(agencia_id){
    this.unidadeSvc.getUnidadesByUsuarioAndCliente(this.authSvc.getUsuarioId(), agencia_id).then((data: any) => {
      this.unidades = data;
    }).catch((err) => {
      console.log(err);
    });
  }
  
  pegaVeiculosByUnidade(unidade_id){
    this.veiculoSvc.getByTipoVeiculo(unidade_id, 1).then((data: any[]) => {
      this.veiculos = data;
		}).catch((err) => {
			console.log(err);
		});
  }

  onChangeAgencia(e){
    this.formChecklist.controls.unidade_id.setValue(null);
    this.formChecklist.controls.veiculo_id.setValue(null);
    this.unidadeSvc.getUnidadesByUsuarioAndCliente(this.authSvc.getUsuarioId(), e.cliente_id).then((data: any) => {
      this.unidades = data;
    }).catch((err) => {
      console.log(err);
    });
  }

  onChangeUnidade(e){
    this.veiculoSvc.getByTipoVeiculo(e.unidade_id, 1).then((data: any[]) => {
      this.veiculos = data;
		}).catch((err) => {
			console.log(err);
		});
  }

  pegaProfissionais(){
    this.profissionalSvc.getProfissionais().then((data: any[]) => {
			this.profissionais = data;
		}).catch((err) => {
			console.log(err);
		});
  }

  formatMilimetragem(value){
    if(value == null){
      return null;
    }
    else{
      return value.replace('.',',');
    }
  }

  onClickVoltar(){

    let params = 'cliente_id___cliente=' + this.cliente_id___cliente;
    params += "&unidade_id___unidade=" + this.unidade_id___unidade;
    params += "&veiculo_id___veiculo=" + this.veiculo_id___veiculo;
    params += "&check_milimetragem_turno___periodo=" + this.check_milimetragem_turno___periodo;
    params += "&check_milimetragem_data___data_i=" + this.check_milimetragem_data___data_i;
    params += "&check_milimetragem_data___data_f=" + this.check_milimetragem_data___data_f;
    params += "&profissional_id___profissional=" + this.profissional_id___profissional;

    this.router.navigate(['/home/milimetragempneusfiltro/' + params]);

  }
}
